import React from "react";
import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { logOut } from "../../app/loginReducer";
import { LogoutRequestBody } from "../../app/models/auth/loginUser";
import { logout } from "../../http/authentication-services";
import { SignoutIcon } from "../../assets/components/svgs";
import { useOutsideDetect, useCheckMobileScreen } from "../../util/customHooks";
import LoaderContainer from "../shared/loaderContainer/LoaderContainer";
import MenuLogo from "./MenuLogo";
import {
  DropdownButton,
  Dropdown,
  DropdownItem,
  EmailContainer,
  Name,
  Role,
  SignOutButton,
  UserContainer,
} from "./MenuStyles";
import {
  fetchFromCookie,
  getUserName,
  getUserRoles,
} from "../../util/admin-utils";
import { useTheme } from "../../context/themeContext";
import { useTranslation } from "react-i18next";
import { IconButton } from "../primitives/buttons/IconButton";
import { isRTLLanguage } from "../../util/functions";

type Props = {
  email?: JSX.Element;
  loggedIn?: boolean;
};

const MenuTop = ({ email, loggedIn = true }: Props) => {
  const wrapperRef = useRef(null);
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [dropdownIsActive, setDropdownIsActive] = useState(false);
  const userProfile = useAppSelector(
    (state) => state.userManagement.userProfileInfo
  );
  const { t, i18n } = useTranslation();
  const theme = useTheme().theme;
  const isRTL = isRTLLanguage(i18n.language);

  const isMobileScreen = useCheckMobileScreen();

  useOutsideDetect(wrapperRef, () => {
    setDropdownIsActive(false);
  });

  const deleteCookies = async () => {
    document.cookie =
      "session-jwt" + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie =
      "iPlanetDirectoryPro" + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie =
      "amlbcookie" + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  };

  const signOut = async () => {
    setIsLoading(true);
    const logoutBody: LogoutRequestBody = {
      client_id: "oidc_pkce",
      token: fetchFromCookie("access-token") || "", //localStorage.getItem('access-token') || ''
    };
    await logout(logoutBody);
    dispatch(logOut());
    deleteCookies();
    return `${t("T_LOGOUT_MSG")}`;
  };

  return (
    <>
      <LoaderContainer isLoading={isLoading}>
        <MenuLogo loggedIn={loggedIn}>
          {email ? <EmailContainer>{email}</EmailContainer> : null}
          <Dropdown marginLeft={!!email} isRTL={isRTL}>
            <UserContainer>
              <Name>{getUserName(userProfile)}</Name>
              {/* <Role>
                {getUserRoles(userProfile)
                  .map((role: any) => role.name)
                  .join()}
              </Role> */}
            </UserContainer>
            {/* <DropdownButton
              role="dropdownbutton"
              onClick={() => setDropdownIsActive(!dropdownIsActive)}
              theme={useTheme().theme}
            >
              {dropdown}
            </DropdownButton> */}
            {/* {dropdownIsActive && (
              <DropdownItem ref={wrapperRef} style={{ zIndex: "1" }}>
                <Link
                  to="/profile"
                  onClick={() => setDropdownIsActive(!dropdownIsActive)}
                >
                  {t("T_MY_ACCOUNT")}
                </Link>
              </DropdownItem>
            )} */}
          </Dropdown>
          {isMobileScreen ? (
            <IconButton
              className={`!m-0 h-10 w-10 self-center border-none`}
              onClick={signOut}
              style={{ color: theme.primaryAppColor }}
            >
              {SignoutIcon}
            </IconButton>
          ) : (
            <SignOutButton onClick={signOut} theme={useTheme().theme}>
              {t("T_SIGN_OUT")}
            </SignOutButton>
          )}
        </MenuLogo>
      </LoaderContainer>
    </>
  );
};

export default MenuTop;
